import React, { useEffect, useState } from 'react'
import { useGetCountryQuery } from '../../store/api';
import { PencilIcon } from '@heroicons/react/24/outline';
import { Audio } from 'react-loader-spinner'

function CountryViewModal({
    setIsViewModalOpen,
    viewingCountry,
    handleEdit
}) {

    const [activeTab, setActiveTab] = useState('universities');

    const [data, setData] = useState([])
    const [universities, setUniversities] = useState([])
    const [applications, setApplications] = useState([])

    const { data: response, isLoading, isSuccess } = useGetCountryQuery(viewingCountry.id)

    useEffect(() => {
        if (!isLoading && response) {
            setData(response.data)
            setUniversities(response.data.universities || [])

            const DATA = []

            if (response.data.universities) {
                response.data.universities.forEach(item => {
                    const app = item?.applications
                    if (app && Array.isArray(app)) {
                        app.forEach(item => {
                            if (item?.student) {
                                DATA.push(item.student)
                            }
                        })
                    }
                });
            }
            setApplications(DATA)
        }
    }, [response, isLoading, isSuccess])

    if (isLoading) {
        return (
            <div className='fixed inset-0 flex items-center bg-white opacity-[.5] justify-center'>
                <Audio
                    height="80"
                    width="80"
                    radius="9"
                    color="green"
                    ariaLabel="loading"
                    wrapperStyle
                    wrapperClass
                />
            </div>
        )
    }

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={() => setIsViewModalOpen(false)} />

                <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full sm:p-6">
                    <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center space-x-3">
                            <div className={`h-3 w-3 rounded-full ${viewingCountry.is_active ? 'bg-green-500' : 'bg-red-500'}`}></div>
                            <h3 className="text-lg font-medium text-gray-900">
                                {viewingCountry.name} - Ətraflı Məlumat
                            </h3>
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
                                {viewingCountry.code}
                            </span>
                        </div>
                        <button
                            onClick={() => setIsViewModalOpen(false)}
                            className="text-gray-400 hover:text-gray-600"
                        >
                            <span className="text-2xl">&times;</span>
                        </button>
                    </div>

                    {/* City details */}
                    <div className="mb-6 bg-blue-50 rounded-lg p-4 border border-blue-200">
                        <h4 className="font-medium text-blue-900 mb-3">Ölkə Məlumatları</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div>
                                <div className="text-sm font-medium text-gray-500">Ölkə Adı</div>
                                <div className="text-sm text-gray-900">{viewingCountry.name}</div>
                            </div>
                            <div>
                                <div className="text-sm font-medium text-gray-500">Status</div>
                                <div className="text-sm text-gray-900">
                                    {viewingCountry.is_active ? 'Aktiv' : 'Deaktiv'}
                                </div>
                            </div>
                            <div>
                                <div className="text-sm font-medium text-gray-500">Yaradılma Tarixi</div>
                                <div className="text-sm text-gray-900">{new Date(viewingCountry.created_at).toLocaleDateString('az-AZ')}</div>
                            </div>
                        </div>
                    </div>

                    {/* Tabs */}
                    <div className="border-b border-gray-200 mb-6">
                        <nav className="-mb-px flex space-x-8">
                            <button
                                onClick={() => setActiveTab('universities')}
                                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'universities'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                Universitetlər ({universities.length})
                            </button>
                            <button
                                onClick={() => setActiveTab('applications')}
                                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'applications'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                Müraciətlər ({applications.length})
                            </button>
                        </nav>
                    </div>

                    {/* Tab Content */}
                    <div className="min-h-64">
                        {activeTab === 'universities' && (
                            <div className="space-y-3">
                                {universities.length > 0 ? (
                                    universities.map((uni) => (
                                        <div key={uni.id} className="bg-white p-4 rounded-lg border border-gray-200 hover:border-blue-300 transition-colors">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center space-x-3">
                                                    <div className="h-3 w-3 bg-blue-600 rounded-full"></div>
                                                    <div>
                                                        <div className="font-medium text-gray-900">{uni.name || 'N/A'}</div>
                                                        <div className="text-sm text-gray-500">{viewingCountry.name}</div>
                                                    </div>
                                                </div>
                                                <div className="text-right">
                                                    <div className="text-xs text-blue-600 font-medium">Reytinq #{uni.ranking || 'N/A'}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-8">
                                        <div className="mx-auto h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                                            <svg className="h-6 w-6 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                            </svg>
                                        </div>
                                        <h5 className="text-lg font-medium text-gray-900 mb-2">Universitet tapılmadı</h5>
                                        <p className="text-gray-500">Bu şəhərdə hələ universitet qeydiyyatda deyil</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {activeTab === 'applications' && (
                            <div className="space-y-3">
                                {applications.length > 0 ? (
                                    applications.map((student) => (
                                        <div key={student.id} className="bg-white p-4 rounded-lg border border-gray-200 hover:border-green-300 transition-colors">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center space-x-3">
                                                    <div className="h-10 w-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
                                                        <span className="text-xs font-bold text-white">
                                                            {student.first_name?.[0] || ''}{student.last_name?.[0] || ''}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <div className="font-medium text-gray-900">
                                                            {student.first_name || ''} {student.last_name || ''}
                                                        </div>
                                                        <div className="text-sm text-gray-500">{student.phone || 'N/A'}</div>
                                                        <div className="text-xs text-gray-400">
                                                            Universitetlər: {student.applied_universities || 'N/A'}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="text-right">
                                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                                                        {student.status?.name || 'N/A'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-8">
                                        <div className="mx-auto h-12 w-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                                            <svg className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                                            </svg>
                                        </div>
                                        <h5 className="text-lg font-medium text-gray-900 mb-2">Müraciət tapılmadı</h5>
                                        <p className="text-gray-500">Bu şəhərdəki universitetlərə hələ heç bir müraciət yoxdur</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="mt-6 flex justify-end space-x-3">
                        <button
                            onClick={() => {
                                setIsViewModalOpen(false);
                                handleEdit(viewingCountry);
                            }}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
                        >
                            <PencilIcon className="-ml-1 mr-2 h-4 w-4" />
                            Redaktə Et
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CountryViewModal